import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureRemixErrorBoundaryError } from '@sentry/remix';

import { type MoreArticlesIndexProps, MoreArticlesWithQuery } from '@cx-modules/more-articles';

export const MoreArticles = (props: Omit<MoreArticlesIndexProps, 'i18n'>) => {
  const { i18n } = useTranslation();
  const articlesPage = props.requestUrl
    ? parseInt(new URL(props.requestUrl).searchParams.get('articlesPage') || '1')
    : 1;

  const localProps: Omit<MoreArticlesIndexProps, 'i18n'> = {
    ...props,
    articlesPage,
  };
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureRemixErrorBoundaryError(error);
        return null;
      }}
    >
      <Suspense fallback={null}>
        <MoreArticlesWithQuery {...localProps} i18n={i18n} />
      </Suspense>
    </ErrorBoundary>
  );
};
